import { CompanyFilter } from "@/models/Company";
import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import CompanyPlace, { CompanyPlaceFilter } from "@/models/CompanyPlace";

export const GET_COMPANIES = "get_companies";
export const GET_COMPANY = "get_company";
export const EDIT_COMPANY = "edit_company";
export const DELETE_COMPANY = "delete_company";

export const GET_COMPANY_PLACES = "get_company_places";
export const SAVE_COMPANY_PLACE = "save_company_place";
export const GET_COMPANY_PLACE = "get_company_place";
export const DESTROY_COMPANY_PLACE = "destroy_company_place";
export const UPLOAD_COMPANY_PLACES = "upload_company_places";

@Component
export default class CompanyMixin extends Vue {
  path = `${BASE_API_URL}companies`;
  readonly clientsPath = `${BASE_API_URL}clients`;

  getCompanies(payload: CompanyFilter) {
    const path = `${this.path}${payload.toParams()}`;
    return this.$httpGet(path, GET_COMPANIES);
  }

  getCompany(id: string) {
    const path = `${this.path}/${id}`;
    return this.$httpGet(path, GET_COMPANY);
  }

  createCompany(data: any) {
    return this.$httpPost(this.path, EDIT_COMPANY, data);
  }

  updateCompany(data: any) {
    const path = `${this.path}/${data.id}`;
    return this.$httpPut(path, EDIT_COMPANY, data);
  }

  uploadCompanyLogo(id: string, data: any) {
    const path = `${this.path}/${id}/upload`;
    const formData = new FormData();
    formData.append("logo", data.logo);
    return this.$httpPut(path, EDIT_COMPANY, formData);
  }

  deleteCompany(id: string) {
    return this.$httpDelete(`${this.path}/${id}`, DELETE_COMPANY, { id });
  }

  getCompanyPlaces(payload: CompanyPlaceFilter) {
    const path = `${this.clientsPath}/client_places${payload.toParams()}`;
    return this.$httpGet(path, GET_COMPANY_PLACES);
  }

  createCompanyPlace(payload: CompanyPlace) {
    return this.$httpPost(
      this.clientsPath + "/client_places",
      SAVE_COMPANY_PLACE,
      payload,
    );
  }

  updateCompanyPlace(payload: CompanyPlace) {
    return this.$httpPut(
      this.clientsPath + "/client_places/" + payload.id,
      SAVE_COMPANY_PLACE,
      payload,
    );
  }

  getCompanyPlace(id: string) {
    return this.$httpGet(
      this.clientsPath + "/client_places/" + id,
      GET_COMPANY_PLACE,
    );
  }

  destroyCompanyPlace(id: string) {
    return this.$httpDelete(
      this.clientsPath + "/client_places/" + id,
      DESTROY_COMPANY_PLACE,
      { id },
    );
  }
  uploadCompanyPlaces(companyId: string, document: File) {
    const formData = new FormData();
    formData.append("document", document);
    formData.append("kind", "client_places");
    return this.$httpPost(
      `${this.path}/${companyId}/client_places/upload`,
      UPLOAD_COMPANY_PLACES,
      formData,
    );
  }
}
